// Copyright (c) 2024 Deere & Company

import SearchFilters from '../../../shared/state/search-filters';
import actions from '../../actions-list';
import {getDefaultState as getWipDefaultState} from '../state';

const resetSearchFilters = state =>
    SearchFilters.update(state, {
        $set: getWipDefaultState().amountOfUseSearchFilters
    });

const updateSearchFilters = (state, action) =>
    SearchFilters.update(state, {
        [action.property]: {
            $set: action.payload
        }
    });

export default (state = getWipDefaultState().amountOfUseSearchFilters, action) => {

    const actionTypes = {
        [actions.RESET_TCSM_DUPLICATE_PIN_PLATE_SEARCH_FILTERS]: resetSearchFilters,
        [actions.UPDATE_TCSM_AMOUNT_OF_USE_REQUESTS_FILTER_BY]: updateSearchFilters,
        [actions.UPDATE_TCSM_AMOUNT_OF_USE_REQUESTS_SORT_BY]: updateSearchFilters,
        [actions.UPDATE_TCSM_AMOUNT_OF_USE_REQUESTS_SORT_DIRECTION]: updateSearchFilters
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/amount-of-use-search-filters.js